import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';
import red from '@material-ui/core/colors/red';
import Slide from '@material-ui/core/Slide';

const styles = () => ({
  highlight: {
    fontWeight: 'bold',
    color: red[600],
  },
  dialogContentContainer: {
    padding: '0 20px 20px 20px',
  },
  dialogText: {
    fontSize: 14,
    marginBottom: 10,
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

function startExamDialog(props) {
//   const classes = this.useStyles();
  const { onClose, open, exam, classes, handleExamStarted } = props;

  if (!exam) return null;

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="start-exam-dialog"
      open={open}
      TransitionComponent={Transition}
    >
      <DialogTitle id="start-exam-dialog-title">Prüfung starten</DialogTitle>
      <DialogContent className={classes.dialogContentContainer}>
        <Typography className={classes.dialogText}>
            Wenn Sie diese Prüfung starten haben Sie genau
            <span className={classes.highlight}> {exam.duration} </span>
            Minuten Zeit diese abzuschließen.
            Sollten Sie die Prüfung nicht in der vorgegeben Zeit beendet haben,
            so werden nur die bis zu diesem Zeitpunkt beantworteten Fragen gewertet.
        </Typography>
        <Typography className={classes.dialogText}>
            Für die positive Absolvierung der Prüfung müssen mindestens
            <span className={classes.highlight}> {Math.round(exam.scoreToPass * 100)}% </span>
            der Fragen richtig beantwortet werden.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
            Abbrechen
          </Button>
        <Button onClick={() => handleExamStarted(exam.test)} color="primary" variant="contained" style={{ color: 'white' }}>
            Prüfung starten
          </Button>
      </DialogActions>
    </Dialog>
  );
}

startExamDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  exam: PropTypes.object,
  classes: PropTypes.object.isRequired,
  handleExamStarted: PropTypes.func,
};

startExamDialog.defaultProps = {
  open: false,
  exam: null,
  handleExamStarted: () => {}
};

export default withStyles(styles)(startExamDialog);



// WEBPACK FOOTER //
// ./src/app/main/exams/start-exam-dialog.js